<script>
    export let context; context;
</script>
<div>
    <section class="section">
        <h1 class="title">
            Bullying
        </h1>
        <div class="content">
            Bullying is a current high profile topic even in the adult world. Here is a short film giving a child's view
            of what it is and what to do about it.
            <br/>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/fWgcsdJ86Do" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </section>
    <section class="section">
        <h1 class="title">
            Feelings
        </h1>
        <div class="content">

            Our feelings can be powerful and not always easy to understand. Sometimes we might feel happy or sad without
            really knowing why. We might feel guilty about some feelings, like anger, or jealousy. Or sometimes we might
            not even know what to call the emotion we are feeling. At The Skill Tree Company we think it is important to
            give our feelings a name, and accept them, just the way they are. Click here to see a short film on this.

            <br/>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/w7USjA0N01o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </section>
    <section class="section">
        <h1 class="title">
            Reading
        </h1>
        <div class="content">
            Please find below our recommended reading. We would appreciate if you decide to buy any of these books for
            yourself that you buy through our affiliate links as it helps us to fund our research for more resources.
            <br /><br />
            The Highly Sesitive Child - Elaine N Aron, Ph.decide
            <br/>
            The bible for parents of sensitve childrenRecommended Reading
            We would greatly appreciate if you could use the affiliate links to buy any of these resources as this will help us to fund our research for more resources.
            
            <br /><br />	
            The Strong Sensitive Boy - Help your Son become a happy confident Man - Ted Zeff
            <br/>
            Good reading for what it is like to be sensitive and interviews highly sensitive men who relate their difficulties in childhood etc - a few suggestions given.	
            <br /><br />
            Make your sensitivity work for you - Alice Muir
            <br/>
            Available as an audio book
            A book more for adults but goes through the traits linked with sensitivity. Good suggestions on calming the mind, body, building self-esteem etc. A book to refer to on a regular basis.	
            <br /><br />
            Calmer, Easier, Happier Parenting - Noёl Janis-Norton
            <br/>
            As sensitive children can be strong willed and their emotions easily aroused, good parenting skills can really help to keep things calm. I have found the tips in this book extremely useful although they are general for any child it can really help to reduce the anxieties of a sensitive child.	
            <br /><br />
            Bullies, Bigmouths and so-called Friends - J. Alexander
            <br/>
            A fantastic guide to bully proofing for 7-12 year olds. Lots of great ideas and a fresh way of looking at problems that will even make your child laugh, though the points are serious and the tips extremely useful. Highly recommended.	
            <br /><br />
            The Complete Secrets of Happy Children - Steve Biddulph
            <br/>
            Something of a classic now, this excellent parenting manual is more relevant than ever. A must read.	
            <br /><br />
            Overcoming Your Child’s Fears and Worries - C. Cresswell, L. Willetts
            <br/>
            A useful book for parents to use with children whose anxieties have grown too dominant in their lives. Based on cognitive behavioural techniques, the writers, who are experts in childhood anxiety, advise on how to challenge unhelpful cycles of thought and how to help children face and manage their worries, using a programme of gradual exposure.	
            <br /><br />
            What to Do When You Worry Too Much - Dawn Huebner
            <br/>
            This well illustrated book helps younger children to deal with worries and anxiety, learning to contain, control and eventually rid themselves of these unwanted thoughts and feelings. Ideal for parent and child to share, and might be used with children as young as 5 up to around 10.	
            <br /><br />
            Stick Up For Yourself - Kaufman, Raphael, Espeland
            <br/>
            A self-help manual for ages 8-12, promoting the building of confidence, self esteem and personal power. Adapted from a programme taught to adults, this book introduces some big ideas on feelings and relationships in a way that children can understand and work with.	
            <br /><br />
            Taming The Tiger Parent - Tanith Carey
            <br/>
            Great read on parenting without all the push and shove of “The Battle Hymn of the Tiger Mother” – a much better approach especially for the sensitive child. Really interesting research into what is going wrong with pressurised parenting around the world.	
            <br /><br />
            All Too Much for Oliver - Leila Boukarim
            <br/>
            For children
            Lovely book for young children to read that will help them to understand and make the best of their sensitivity.	
        </div>
    </section>
</div>